import AdminRow from "./AdminRow";
import "../../styles/table.css";

export default function AdminTable({ admins, onView, onEdit, onDelete }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Administrateur</th>
            <th>Téléphone</th>
            <th>Nom d'utilisateur</th>
            <th className="center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {admins.map((admin) => (
            <AdminRow
              key={admin.id}
              admin={admin}
              onView={onView}
              onEdit={onEdit}
             onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
